module.exports = __webpack_public_path__ + "static/media/viewposts.572e9b0a.png";